import { type DependencyResult, getAvailableResult } from "DependencyResult";
import type { Entity } from "breeze-client";

export function isNew(args: unknown[], entity: Entity): DependencyResult {
  if (args.length !== 0) {
    throw new Error("Expected no arguments.");
  }

  return getAvailableResult(entity.entityAspect.entityState.isAdded());
}
